import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import translationEN from './translations/en.json';
import translationTR from './translations/tr.json';
import translationPT_BR from './translations/pt-br.json';
import translationES_CL from './translations/es-cl.json';
import { languagesList, toLangTag } from './languagesList';

// "pt-BR" / "PT_BR" / "en-US" -> key of languagesList ("pt_BR", "en").
export const toIsoLanguage = (code) => {
    if (!code) {
        return 'en';
    }
    const [language, region] = code.replace('-', '_').split('_');
    const withRegion = `${language.toLowerCase()}_${region?.toUpperCase()}`;
    return languagesList[withRegion] ? withRegion : language.toLowerCase();
};

const resources = {
    en: {
        translation: translationEN,
    },
    tr: {
        translation: translationTR,
    },
    pt_BR: {
        translation: translationPT_BR,
    },
    es_CL: {
        translation: translationES_CL,
    },
};

// Screen readers use <html lang> for pronunciation.
i18n.on('languageChanged', (language) => {
    document.documentElement.lang = toLangTag(toIsoLanguage(language));
});

i18n.use(LanguageDetector)
    .use(initReactI18next)
    .init({
        fallbackLng: 'en',
        debug: process.env.NODE_ENV === 'development',
        detection: {
            order: ['querystring', 'cookie', 'localStorage', 'navigator'],
            lookupQuerystring: 'lang',
            convertDetectedLanguage: toIsoLanguage,
        },
        // React already escapes rendered values; escaping again would show e.g. "&amp;" in the UI.
        interpolation: { escapeValue: false },
        resources,
    });

export default i18n;
